import React from 'react';
import { Helmet } from 'react-helmet-async';

const SEOHead = ({ 
  title = "Designbiz.in - भारतातील Designer साठी #1 Business Platform",
  description = "Freelance Designers साठी Complete Business Management System. Lead Tracking, Professional Invoices, Payment Management, WhatsApp Integration. 100% FREE!",
  keywords = "designbiz, designer business, graphic designer software, freelance designer tools, lead management, invoice software, CRM for designers",
  image = "https://static.prod-images.emergentagent.com/jobs/c4b213e5-68b9-418e-b70d-d61b0c80bb0a/images/c179113cecf1651f0ac11299d03ab224db6756c91859e660016a9e8fb2147f5b.png",
  url = "https://designbiz.in/",
  type = "website"
}) => {
  return (
    <Helmet>
      {/* Primary Meta Tags */}
      <title>{title}</title>
      <meta name="title" content={title} />
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      
      {/* Open Graph / Facebook */}
      <meta property="og:type" content={type} />
      <meta property="og:url" content={url} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      
      {/* Twitter */}
      <meta property="twitter:card" content="summary_large_image" />
      <meta property="twitter:url" content={url} />
      <meta property="twitter:title" content={title} />
      <meta property="twitter:description" content={description} />
      <meta property="twitter:image" content={image} />
      
      {/* Canonical */}
      <link rel="canonical" href={url} />
    </Helmet>
  );
};

export default SEOHead;
